import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AppService } from '@shared/services/app.service';
import { Observable } from 'rxjs';
import { CustomizationService } from '../../services/customization.service';
import { BrandModel } from '../../models/brand.model';

@Injectable({
  providedIn: 'root'
})
export class BrandResolver implements Resolve<any> {
  constructor(private appService: AppService,
              private customizationService: CustomizationService,) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let host = 'vatra.live';
    if (this.isVeloplaneta()) {
      host = 'veloplaneta.vatra.live';
    }
    if (this.isBikelab()) {
      host = 'bikelab.vatra.live';
    }
    return new Observable(observer => {
      this.appService.getBranding(host).subscribe((brand: BrandModel) => {
        this.customizationService.logoUrl = brand.logoUrl;
        this.customizationService.title = brand.brandName;
        this.appService.setThemeColors(
          brand.backgroundColor as string,
          brand.textColor as string,
          brand.menuColor as string
        );
        observer.next(brand);
        observer.complete();
      });
    });
  }

  public isVeloplaneta(): boolean {
    return window.location.hostname.indexOf('veloplaneta.vatra.live') !== -1;
  }

  public isBikelab(): boolean {
    return window.location.hostname.indexOf('bikelab.vatra.live') !== -1;
  }
}
